import React from 'react';
import Grid from '@material-ui/core/Grid';
import { SunburstChart } from 'app/components/Charts/sunburst';
import { SectorsFragmentTable } from 'app/fragments/sectors-fragment/common/table';

interface SectorsFragmentLayoutProps {
  showViz: boolean;
  sunburstData: any;
  pageParam: string;
  sunburstCount: number;
  detailBaseFilter: string;
  selected: string;
  setSelected: (value: string) => void;
  prevSelections: string[];
  setPrevSelections: (value: string[]) => void;
}

export const SectorsFragmentLayout = (props: SectorsFragmentLayoutProps) => {
  return (
    <Grid item sm={12} md={12} lg={12}>
      {props.showViz ? (
        <SunburstChart
          data={props.sunburstData}
          activitiesCount={props.sunburstCount}
          selected={props.selected}
          setSelected={props.setSelected}
          prevSelections={props.prevSelections}
          setPrevSelections={props.setPrevSelections}
        />
      ) : (
        <SectorsFragmentTable
          pageParam={props.pageParam}
          detailBaseFilter={props.detailBaseFilter}
          selected={props.selected}
          setSelected={props.setSelected}
          prevSelections={props.prevSelections}
          setPrevSelections={props.setPrevSelections}
        />
      )}
    </Grid>
  );
};
